import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function Footer() {
  const { t } = useTranslation()
  const currentYear = new Date().getFullYear()

  return (
    <footer className="w-full py-6 px-4 mt-auto">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
          {/* Navigation Links */}
          <nav className="flex flex-wrap justify-center gap-6">
            <Link
              to="/spielanleitung"
              className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.spielanleitung')}
            </Link>
            <Link
              to="/faq"
              className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.faq')}
            </Link>
            <Link
              to="/impressum"
              className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.impressum')}
            </Link>
            <Link
              to="/datenschutz"
              className="hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
            >
              {t('footer.datenschutz')}
            </Link>
          </nav>

          {/* Copyright */}
          <div className="text-center">
            <p>© {currentYear} Planning Poker by Andreas van Hulst. {t('footer.allRightsReserved')}</p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
